var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-message-template-form',{attrs:{"id":Number(_vm.$route.params.id),"confirm":_vm.confirm},on:{"submit":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }